export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDes: true,
    topLine: 'Welcome to Vocco',
    topLine2: 'Explore our beautiful homes',
    headline: '',
    headline2: 'Mer än bara middag',
    description: 'Where dining meets nightlife. Discover an elevated experience combining exceptional atmosphere, music and unforgettable evenings.',
    description2:'Där matupplevelser möter nattliv. Upptäck en exklusiv helhetsupplevelse med en unik atmosfär, fantastisk musik och oförglömliga kvällar.',
    imgStart: false,
    img: require('../../AssetsForIndex/ice.jpeg'),
    img2: require('../../AssetsForIndex/food.jpg'),
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false,
}